export default "__VITE_ASSET__LA1ShM1c__"